<template>
  <input
    :type="type ?? 'text'"
    :name="name"
    :class="[
      'block w-full rounded-md border border-background-fg/6 bg-background-fg/5 px-3 py-2 text-sm font-semibold focus:outline-none sm:text-sm',
      hasError
        ? 'border-error text-error placeholder:text-error focus:border-error focus:ring-error'
        : 'focus:border-primary focus:ring-primary',
    ]"
    :placeholder="placeholder"
    :value="modelValue"
    :aria-invalid="hasError"
    :disabled="disabled"
    enterKeyHint="done"
    autocomplete="off"
    @input="
      emit(
        'update:modelValue',
        ($event?.target as HTMLInputElement).value
      )
    "
    @change="emit('change', $event)"
    @blur="emit('blur', $event)"
    @keydown.enter="handleEnter"
  />
</template>

<script setup lang="ts">
defineProps<{
  type?: string
  modelValue: string | undefined
  placeholder?: string
  name?: string
  hasError?: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  (eventName: "update:modelValue", value: string): void
  (eventName: "change", event: Event): void
  (eventName: "blur", event: Event): void
}>()

const handleEnter = (event: Event) =>
  (event?.target as HTMLInputElement)?.blur()
</script>
